__turbopack_context__.v({
  "activeSectionTab": "LinkedInGenerator-module__2Q8LnW__activeSectionTab",
  "additionalTips": "LinkedInGenerator-module__2Q8LnW__additionalTips",
  "bulletPoint": "LinkedInGenerator-module__2Q8LnW__bulletPoint",
  "container": "LinkedInGenerator-module__2Q8LnW__container",
  "copiedIndicator": "LinkedInGenerator-module__2Q8LnW__copiedIndicator",
  "copyAllButton": "LinkedInGenerator-module__2Q8LnW__copyAllButton",
  "copyButton": "LinkedInGenerator-module__2Q8LnW__copyButton",
  "footer": "LinkedInGenerator-module__2Q8LnW__footer",
  "header": "LinkedInGenerator-module__2Q8LnW__header",
  "headerContent": "LinkedInGenerator-module__2Q8LnW__headerContent",
  "headerIcon": "LinkedInGenerator-module__2Q8LnW__headerIcon",
  "headlineCard": "LinkedInGenerator-module__2Q8LnW__headlineCard",
  "headlineDescription": "LinkedInGenerator-module__2Q8LnW__headlineDescription",
  "headlineHeader": "LinkedInGenerator-module__2Q8LnW__headlineHeader",
  "headlineText": "LinkedInGenerator-module__2Q8LnW__headlineText",
  "headlinesList": "LinkedInGenerator-module__2Q8LnW__headlinesList",
  "highImpact": "LinkedInGenerator-module__2Q8LnW__highImpact",
  "highImpactBadge": "LinkedInGenerator-module__2Q8LnW__highImpactBadge",
  "priorityMustHave": "LinkedInGenerator-module__2Q8LnW__priorityMustHave",
  "priorityNiceToHave": "LinkedInGenerator-module__2Q8LnW__priorityNiceToHave",
  "priorityRecommended": "LinkedInGenerator-module__2Q8LnW__priorityRecommended",
  "proTip": "LinkedInGenerator-module__2Q8LnW__proTip",
  "proTipIcon": "LinkedInGenerator-module__2Q8LnW__proTipIcon",
  "reframeAfter": "LinkedInGenerator-module__2Q8LnW__reframeAfter",
  "reframeArrow": "LinkedInGenerator-module__2Q8LnW__reframeArrow",
  "reframeBefore": "LinkedInGenerator-module__2Q8LnW__reframeBefore",
  "reframeCard": "LinkedInGenerator-module__2Q8LnW__reframeCard",
  "reframeComparison": "LinkedInGenerator-module__2Q8LnW__reframeComparison",
  "reframeLabel": "LinkedInGenerator-module__2Q8LnW__reframeLabel",
  "reframeScenario": "LinkedInGenerator-module__2Q8LnW__reframeScenario",
  "reframeWhy": "LinkedInGenerator-module__2Q8LnW__reframeWhy",
  "reframesIntro": "LinkedInGenerator-module__2Q8LnW__reframesIntro",
  "reframesSection": "LinkedInGenerator-module__2Q8LnW__reframesSection",
  "sectionContent": "LinkedInGenerator-module__2Q8LnW__sectionContent",
  "sectionIcon": "LinkedInGenerator-module__2Q8LnW__sectionIcon",
  "sectionIntro": "LinkedInGenerator-module__2Q8LnW__sectionIntro",
  "sectionLabel": "LinkedInGenerator-module__2Q8LnW__sectionLabel",
  "sectionTab": "LinkedInGenerator-module__2Q8LnW__sectionTab",
  "sectionTabs": "LinkedInGenerator-module__2Q8LnW__sectionTabs",
  "skillCategoryIcon": "LinkedInGenerator-module__2Q8LnW__skillCategoryIcon",
  "skillPriorityGroup": "LinkedInGenerator-module__2Q8LnW__skillPriorityGroup",
  "skillPriorityTitle": "LinkedInGenerator-module__2Q8LnW__skillPriorityTitle",
  "skillTag": "LinkedInGenerator-module__2Q8LnW__skillTag",
  "skillTags": "LinkedInGenerator-module__2Q8LnW__skillTags",
  "skillsGrid": "LinkedInGenerator-module__2Q8LnW__skillsGrid",
  "skillsLegend": "LinkedInGenerator-module__2Q8LnW__skillsLegend",
  "styleAchievement": "LinkedInGenerator-module__2Q8LnW__styleAchievement",
  "styleAspirational": "LinkedInGenerator-module__2Q8LnW__styleAspirational",
  "styleBadge": "LinkedInGenerator-module__2Q8LnW__styleBadge",
  "styleHybrid": "LinkedInGenerator-module__2Q8LnW__styleHybrid",
  "summaryBlock": "LinkedInGenerator-module__2Q8LnW__summaryBlock",
  "summaryContent": "LinkedInGenerator-module__2Q8LnW__summaryContent",
  "summaryHeader": "LinkedInGenerator-module__2Q8LnW__summaryHeader",
  "tipCard": "LinkedInGenerator-module__2Q8LnW__tipCard",
  "tipHeader": "LinkedInGenerator-module__2Q8LnW__tipHeader",
  "tipSection": "LinkedInGenerator-module__2Q8LnW__tipSection",
  "tipText": "LinkedInGenerator-module__2Q8LnW__tipText",
  "tipsList": "LinkedInGenerator-module__2Q8LnW__tipsList",
});
